import React from 'react';
import Tooltip from '../../common/Tooltip';

interface TimesheetFooterProps {
    isEditing: boolean;
    isGenerateDisabled: boolean;
    isGenerating: boolean;
    isResendDisabled?: boolean;
    isResending?: boolean;
    disabledTooltip?: string;
    onAddExtraRate?: () => void;
    onResendEmail?: () => void;
    onToggleEdit: () => void;
    onGenerate: () => void;
    onCancel: () => void;
    editDisabled?: boolean;
}

export const TimesheetFooter: React.FC<TimesheetFooterProps> = React.memo(({
    isEditing,
    isGenerateDisabled,
    isGenerating,
    isResendDisabled = true,
    isResending = false,
    disabledTooltip,
    onAddExtraRate,
    onResendEmail,
    onToggleEdit,
    onGenerate,
    onCancel,
    editDisabled = false,
}) => {
    const generateButton = (
        <button
            className="timesheet-modal__primary-btn"
            type="button"
            onClick={onGenerate}
            disabled={isGenerateDisabled || isGenerating}
        >
            {isGenerating ? 'Generating...' : 'Generate'}
        </button>
    );

    return (
        <div className="timesheet-modal__footer">
            <button
                type="button"
                className="timesheet-edit-btn"
                onClick={onToggleEdit}
                disabled={isGenerating || editDisabled}
            >
                <i className="icon icon-pencil-3" />
                {isEditing ? 'Done' : 'Edit Data'}
            </button>
            {onAddExtraRate && (
                <button
                    type="button"
                    className="timesheet-modal__secondary-btn"
                    onClick={onAddExtraRate}
                    disabled={isGenerating}
                >
                    Add extra rate
                </button>
            )}
            <div className="timesheet-modal__footer-actions">
                <button
                    className="timesheet-modal__secondary-btn"
                    type="button"
                    onClick={onResendEmail}
                    disabled={!onResendEmail || isResendDisabled || isGenerating || isResending}
                >
                    {isResending ? 'SENDING...' : 'RESEND EMAIL'}
                </button>
                {disabledTooltip ? (
                    <Tooltip
                        tooltip={disabledTooltip}
                        delayShow={0}
                        delayHide={150}
                        placement="top"
                        tooltipClassName="timesheet-tooltip"
                        overlayId="generate-btn-tooltip"
                    >
                        {generateButton}
                    </Tooltip>
                ) : (
                    generateButton
                )}
                <button
                    className="timesheet-modal__secondary-btn"
                    type="button"
                    onClick={onCancel}
                    disabled={isGenerating}
                >
                    Cancel
                </button>
            </div>
        </div>
    );
});

TimesheetFooter.displayName = 'TimesheetFooter';

